module.exports = __webpack_public_path__ + "img/recover.14979a91.png";